import React from 'react'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

// Registrar componentes
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend)

const GraficoTopProdutoQuantidade = ({ indicador }) => {
  const data = {
    labels: indicador.topMaiorEstoque.labels,
    datasets: [
      {
        label: 'Quantidade de Saídas',
        data: indicador.topMaiorEstoque.total,
        backgroundColor: '#224650',
      },
    ],
  }

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 10,
        bottom: 10,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        ticks: {
          font: {
            size: 10,
          },
        },
      },
    },
  }

  return (
    <div style={{ width: '100%', height: '180px', textAlign: 'center' }}>
      <Bar data={data} options={options} />
    </div>
  )
}

export default GraficoTopProdutoQuantidade
